import React from 'react';
import { ProductCategory } from '../../../../../../models/interfaces/ProductCategory.interface';
import {
  CustomDataTableConfig,
  HeadCell,
} from '../../../../../../commons/components/custom-data-table/custom-data-table-config.model';
import { useNavigate } from 'react-router-dom';
import CustomDataTableComponent from '../../../../../../commons/components/custom-data-table/custom-data-table.component';
import routeService from '../../../../../../routes/route.service';

interface CategoryTableComponentProps {
  userId: number;
  businessObjectId: number;
  categories?: ProductCategory[];
}

export default function CategoryTableComponent(props: CategoryTableComponentProps) {
  const navigate = useNavigate();

  const headCells: HeadCell[] = [
    { id: 'id', field: 'id', label: 'ID' },
    { id: 'displayOrder', field: 'displayOrder', label: 'Display order' },
    { id: 'name', field: 'name', label: 'Name' },
    { id: 'description', field: 'description', label: 'Description' },
  ];

  const tableConfig: CustomDataTableConfig = {
    tableName: 'Categories',
    rowsPerPage: 10,
    headCells,
  };

  const handleSelectRow = (selectedCategory: ProductCategory) => {
    if (selectedCategory?.id) {
      navigate(routeService.getAndFillCategoryDetailPath(props.userId, props.businessObjectId, selectedCategory.id));
    }
  };

  return (
    <CustomDataTableComponent
      tableConfig={tableConfig}
      data={props.categories as ProductCategory[]}
      onSelect={handleSelectRow}
    />
  );
}
